import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FlashMessage } from '@app/src/common/FlashMessage';
import { actionsFlashMessageError } from '@app/src/common/flashMessageError';

export const FlashMessageError: React.FC = () => {
  const dispatch = useDispatch();
  const isShow = useSelector(state => state.flashMessage.show);

  useEffect(() => {
    return () => {
      dispatch(actionsFlashMessageError.closeFlashMessage());
    }
  }, []);

  const handleClickClose = () => {
    console.log('click')
    dispatch(actionsFlashMessageError.closeFlashMessage());
  };

  return (
    <FlashMessage
      message={'Se produjo un error, por favor intente nuevamente en unos minutos.'}
      isClosable
      isDisplay={isShow}
      error
      handleClickClose={handleClickClose}
    />
  )
};
